/**
 * PWA / native-shell interop helpers.
 *
 * Phase 5 (Capacitor) will wrap this web app in a native shell. When running
 * inside that shell, `window.Capacitor` is injected by the Capacitor runtime
 * itself — no `@capacitor/core` import is needed (or wanted) here, since this
 * file must work correctly today, before Capacitor is ever installed.
 *
 * The service worker must NEVER register inside the native shell: Capacitor
 * apps load from a local `capacitor://` / `file://`-backed WebView, and a
 * registered SW there would fight with the native app's own asset loading
 * and caching model.
 */

declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform?: () => boolean;
    };
  }
}

export function isRunningInNativeShell(): boolean {
  return typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();
}
